module.exports = "<div class=\"service\" [ngClass]=\"{'down': !status}\">\r\n  <div class=\"title\">\r\n    <span class=\"circle\" [ngStyle]=\"{'background-color': statusColor}\"></span>\r\n    {{subSystemId}} {{systemId}}\r\n  </div>\r\n  <div class=\"label\">\r\n    {{value}}\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/table-column/services-row/service/service.component.html
// module id = ./src/app/components/table-column/services-row/service/service.component.html
// module chunks = main